import React from 'react';
import {
  Bold,
  Heading1,
  // Heading2,
  // LinkStyled,
  Paragraph,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
} from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Item, Price } from '../../containers/commerce';
import ProductViewKulsyre from '../../components/commerce/ProductViews/ProductViewKulsyre';
import { Grid } from './KulsyreTilFadoel';
import { Content } from './Kulsyre';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Kulsyre" activeSidemenu="KulsyreQuooker">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Kulsyre til Danskvandsanlæg</Heading1>
          <Paragraph bold>
            Vi er ikke associeret med Quooker og de produkter vi sælger er ikke originale Quooker produkter.
          </Paragraph>
          <Paragraph>
            Med tilkobling af vores kulsyreflasker slipper du for at skulle skifte flaske så ofte. Der er ca. 10 gange mere kulsyre i vores 4 kg flasker end i de almindelige små patroner.
          </Paragraph>
          <Paragraph>
            For at tilslutte vores kulsyreflasker til et danskvandsanlæg, skal du bruge en trykregulator samt en 6,3 mm kulsyreslange. Du finder alt, du skal bruge på denne side. Den originale regulator på f.eks. Quookeranlæg (den hvide klods på siden, som den lille flaske skal skrues op i) er indstillet til 3 bar.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <Grid>
            <Content product>
              <Item
                varenr="20601"
                middleImage
                display={ProductViewKulsyre}
                secondDescription={(
                  <React.Fragment>
                    <Paragraph>
                      Passer til langt de fleste danskvandsanlæg, herunder Quooker.
                      Regulatoren skrues direkte på kulsyreflasken (kulsyrenøgle medfølger).
                      Regulerer trykket mellem 1 og 10 bar.
                      Quookers originale trykregulator er indstillet til 3 bar. Vores egen Quooker på kontoret har vi indstillet til 4 bar.
                    </Paragraph>
                    <Paragraph>
                      Kulsyreslangen til danskvandskøleren skubbes direkte ind i John Guest
                      studsen uden brug af værktøj eller spændebånd.
                    </Paragraph>
                  </React.Fragment>
                )}
              />
            </Content>
            <Content product>
              <Item
                varenr="8944"
                middleImage
                display={ProductViewKulsyre}
                customDescription={(
                  <React.Fragment>
                    <Paragraph>
                      <Bold>Vi anbefaler en 4kg kulsyreflaske til det meste hjemmebrug, da den passer fint i de fleste underskabe.</Bold> Der er ca. 10 gange mere kulsyre i vores 4 kg flasker end i de almindelige små patroner.
                    </Paragraph>
                    <Paragraph>
                      Panten på flasken er <Price embPrice varenr="8940" momsIndication />
                    </Paragraph>
                    <Paragraph>
                      Aluminiumsflaske uden stigrør:<br />
                      Diameter 15,4cm | Højde 59cm | Tomvægt 7,25kg
                    </Paragraph>
                  </React.Fragment>
                )}

              />
            </Content>
            <Content product>
              <Item varenr="20942" middleImage display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <TheVideoPlayer url="wDw6fDvnqDc" thumbnail="quooker" />
            </Content>
          </Grid>
        </Col>
      </Row>
    </Container>
    {/*
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Quooker kulsyre: Den bedste og billigste løsning
          </Heading2>
          <Paragraph>
            Er du træt af at skulle skifte patroner med kulsyre til Quooker hele tiden? Måske synes du blot at det er irriterende, at skulle have de små tomme patroner liggende, indtil du kan sende dem retur for refills?
          </Paragraph>
          <Paragraph>
            Slip for en masse besvær ved at bestille vores løsning til Quooker kulsyre. Let, billigt og enkelt.
          </Paragraph>
          <Paragraph>
            Læs mere om <LinkStyled to="/kulsyre">kulsyre</LinkStyled> samt de mange andre anvendelsesmuligheder, der er ved vores CO2-flasker.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Hvad er forskellen ved vores Quooker kulsyre?
          </Heading2>
          <Paragraph>
            Når du bestiller vores løsning til Quooker kulsyre, får du mere for pengene. Vi tilbyder nemlig 4 kg kulsyreflasker, hvilket svarer til ca. 10 gange mere kulsyre end i en almindelig Quooker patron. Du slipper derfor at skifte patronen hele tiden.
          </Paragraph>
          <Paragraph>
            Størrelsen på vores 4 kg kulsyreflasker passer fint i de fleste underskabe, så du ikke behøver at have flasken stående fremme.
          </Paragraph>
          <Paragraph>
            Den største fordel ved at vælge vores løsning til Quooker kulsyre, er uden tvivl den praktiske vinkel. Kulsyreflasken er større og du slipper dermed for at have flere små Quooker flasker liggende, som skal sendes retur og genfyldes flere ad gangen. Med denne løsning af kulsyre til Quooker, skal du blot have genfyldt en enkelt flaske ad gangen. Dette gør det også til en billigere løsning.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Sådan tilkobler du kulsyre til Quooker
          </Heading2>
          <Paragraph>
            Det er let og ligetil at udskifte den originale Quooker kulsyre med vores større kulsyreflaske - og du kan sagtens klare det selv.
          </Paragraph>
          <Paragraph>
            Du starter med at afmontere den originale Quooker kulsyre på siden af den hvide boks. Herefter tages slangen med regulator ud af boksens bagside. Indsæt nu den nye, længere kulsyreslange og monter slangens modsatte ende i den nye trykregulator. Trykregulatoren sættes på kulsyreflasken og du kan nu indstille hvor højt trykket skal være. Quookers egen regulator er indstillet til 3 bar, hvilket du med fordel også kan gøre, for at få nøjagtig samme oplevelse med din nye, større flaske Quooker kulsyre.
          </Paragraph>
          <Paragraph>
            Er du i tvivl om hvordan den nye flaske monteres? Tag et kig på vores videoguide her på siden, hvor vi forklarer hvordan den enkle proces foregår.
          </Paragraph>
          <Paragraph>
            Kulsyreslangen til din nye løsning med kulsyre til Quooker kan vælges i den ønskede længde. Du kan derfor selv vælge om flasken skal stå ved siden af boksen, i skabet ved siden af, om den skal føres ned i kælderen eller noget helt fjerde.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    */}
  </SidemenuLayout>
);
